import { useState, useEffect } from 'react';
import { writesettings, getDmImei } from '../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Checkbox from '../../UI/Checkbox/Checkbox';
import Button from '../../UI/Button/Button';
import Modal from '../../UI/Modal/Modal';
import {Loader} from '../../UI/Loader/Loader';
import './DmGunSectors.css';
import angle from '../../../img/angle.svg';

// Компонент: строка - сектор
function SectorRow({ sector, onEdit, isLoading, hasOverlap }) {
    return (
        <tr className={`sector ${hasOverlap ? 'overlap' : ''}`}>
            <td><span>{sector.id}</span></td>
            <td>
            {isLoading && onEdit==='begin' ? <Loader /> : 
                <Button onClick={() => onEdit(sector, 'begin')}>
                    <span className="btnSector">{sector.beginAngle + '\u00b0'}</span>
                </Button>
                }
            </td>
            <td>
                <p>-</p>
            </td>
            <td>
            {isLoading && onEdit==='end' ? <Loader /> :  
                <Button onClick={() => onEdit(sector, 'end')}>
                    <span className="btnSector">{sector.endAngle + '\u00b0'}</span>
                </Button>
               } 
            </td>
        </tr>
    );
}

function Sectors({ sectors, onEdit, isLoading, overlaps }) {
    return (
        <>
            {sectors.map((sector) => (
                <SectorRow 
                    key={sector.id} 
                    sector={sector} 
                    onEdit={onEdit} 
                    isLoading={isLoading}
                    hasOverlap={overlaps.includes(sector.id)}
                />
            ))}
        </>
    );
}

// Функция проверки перекрытий секторов
function checkSectorOverlaps(sectors) {
    const overlaps = new Set();
    const activeSectors = sectors.filter(s => 
        s.beginAngle !== '...' && s.endAngle !== '...' && 
        s.beginAngle !== 65535 && s.endAngle !== 65535
    );

    // Проверка каждого сектора на пересечение с другими
    for (let i = 0; i < activeSectors.length; i++) {
        const current = activeSectors[i];
        const begin1 = Number(current.beginAngle);
        const end1 = Number(current.endAngle);

        for (let j = i + 1; j < activeSectors.length; j++) {
            const other = activeSectors[j];
            const begin2 = Number(other.beginAngle);
            const end2 = Number(other.endAngle);

            // Проверка пересечения углов
            if ((begin1 <= begin2 && begin2 <= end1) || 
                (begin1 <= end2 && end2 <= end1) ||
                (begin2 <= begin1 && begin1 <= end2) ||
                (begin2 <= end1 && end1 <= end2)) {
                overlaps.add(current.id);
                overlaps.add(other.id);
            }
        }

        // Проверка на полное перекрытие (begin > end)
        if (begin1 > end1) {
            overlaps.add(current.id);
        }
    }

    return Array.from(overlaps);
}

export default function DmGunSectors() {
    const parameter = useSelector((state) => state.dmimei?.data[0]);
    const dispatch = useDispatch();

    const [gunsectors, setGunsectors] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [currentSector, setCurrentSector] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [editType, setEditType] = useState(null);
    const [checked, setChecked] = useState();
    const [angleCurrent, setAngleCurrent] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [overlaps, setOverlaps] = useState([]);
    const [showOverlapWarning, setShowOverlapWarning] = useState(false);

    useEffect(() => { //генерим массив из 9 элементов - секторов
        if (parameter) {
            const createSectors = (count) =>
                Array.from({ length: count }, (_, index) => ({
                    id: `${index + 1}.`,
                    beginAngle: parameter[`sectorOn${index + 1}`] !== 65535 ? parameter[`sectorOn${index + 1}`] : '...',
                    endAngle: parameter[`sectorOff${index + 1}`] !== 65535 ? parameter[`sectorOff${index + 1}`] : '...',
                }));
            const newSectors = createSectors(9);
            setGunsectors(newSectors);
            setOverlaps(checkSectorOverlaps(newSectors));

            // Установка начального состояния чекбокса и режима
            setChecked(parameter.FlagGanUse === 0);
            // setAngleCurrent(parameter?.AngleCurrent || '...')
            setAngleCurrent(parameter?.AngleCurrent !== undefined && parameter?.AngleCurrent !== null 
        ? parameter.AngleCurrent : '...');
        }
    }, [parameter]);

    // Проверка перекрытий при изменении секторов
    useEffect(() => {
        const newOverlaps = checkSectorOverlaps(gunsectors);
        setOverlaps(newOverlaps);
        setShowOverlapWarning(newOverlaps.length > 0);
    }, [gunsectors]);

    // Открытие модального окна
    function openModal(sector, type) {
        setCurrentSector(sector);
        setEditType(type);
        setInputValue(''); // Сброс значения
        setModalOpen(true);
        setHasError(false);
    }

    // Сохранение нового значения сектора
    function saveSectorValue() {
        if (!inputValue) {
            setHasError(true);
            return;
        }
        
        setHasError(false);
        setIsLoading(true);
        
        if (currentSector && editType) {
            const updatedSectors = gunsectors.map((sector) =>
                sector.id === currentSector.id
                    ? {
                          ...sector,
                          [editType === 'begin' ? 'beginAngle' : 'endAngle']: inputValue || '...',
                      }
                    : sector
            );
            setGunsectors(updatedSectors);
            setModalOpen(false);
        }
        
        let angleInput = (inputValue.replace(',', '.')*1).toFixed(1);
        if (angleInput > 359) { angleInput = 359 };
        if (angleInput <= 0 ) { angleInput = 1 };
        if (inputValue === '0') { angleInput = 65535 };
        
        if (editType === 'begin'){
            dispatch(writesettings(parameter?.imei, angleInput, currentSector.id[0]*1+50))
            .then(() => dispatch(getDmImei(parameter?.imei)))
            .catch((error) => console.error('Ошибка при сохранении данных: ', error));
        }
        if (editType === 'end'){
            dispatch(writesettings(parameter?.imei, angleInput, currentSector.id[0]*1+60))
            .then(() => dispatch(getDmImei(parameter?.imei)))
            .catch((error) => console.error('Ошибка при сохранении данных: ', error));
        }
        setIsLoading(false);
    }

    // Обработка изменения чекбокса
    function handleCheckboxChange(event) {
        const inputvalue = 1 - parameter.FlagGanUse; // Инверсия значения
        const num = 50;
        setChecked(event.target.checked);
        // Отправка данных на сервер
        dispatch(writesettings(parameter?.imei, inputvalue, num))
            .then(() => dispatch(getDmImei(parameter?.imei)))
            .catch((error) => console.error('Ошибка при сохранении данных: ', error));
    }

    return (
        <div className="GunSectorCard">
            {/* Чекбокс переключения использования пушки */}
            <div className="GunSectorUse">
                <label>Использовать концевую пушку</label>
                <Checkbox handleCheckboxChange={handleCheckboxChange} checked={checked} id="checkbox3" />
            </div>
            <TransitionGroup>
            {/* Если чекбокс выключен */}
            {!checked ? (
                <CSSTransition key="warningInfo" timeout={500}
                    classNames='gunOn'>
                <div className='warningGunInfo'>
                <h4>Внимание!&nbsp;</h4>
                    <div className='angleGunInfo'>
                        <p> Текущее положение: </p>
                        <h3>{angleCurrent+'\u00b0'}</h3>
                    </div>
                </div>
                </CSSTransition>
            ) : ( <CSSTransition key="barrierOff" timeout={500} classNames="gunOff">
                <div className='gunUseOff'>
                         <h2>Пушки отключены</h2>
                    </div>
                </CSSTransition>
             )}
            </TransitionGroup>

            {/* Предупреждение о перекрытии секторов */}
            {showOverlapWarning && (
                <div className="overlap-warning">
                    <h4 style={{color: 'red'}}>Внимание: Обнаружены перекрывающиеся сектора!</h4>
                </div>
            )}

            <>
                {/* Заголовок таблицы */}
                <div className="sektorsHeader">
                    <h3>Угловое расписание. Сектора.</h3>
                    <div className="sectorBeginEnd">
                        <p>№</p>
                        <img className="angleImg" src={angle} alt="Угол" />
                        <p>Начало</p>
                        <span>-</span>
                        <img className="angleImg" src={angle} alt="Угол" />
                        <p>Конец</p>
                    </div>
                </div>
                {/* Таблица с секторами */}
                <div className="sectorsBody">
                    <table>
                        <tbody>
                            <Sectors 
                                sectors={gunsectors} 
                                onEdit={openModal} 
                                isLoading={isLoading}
                                overlaps={overlaps}
                            />
                        </tbody>
                    </table>
                </div>
            </>
            
            {/* Модальное окно */}
            <Modal open={modalOpen}>
                <div className="modalHeader">
                    <h3>Введите новое значение</h3>
                    <svg
                        onClick={() => setModalOpen(false)}
                        height="30"
                        width="30"
                        viewBox="0 0 200 200"
                    >
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg>
                </div>
                <div className="modalInfo">
                    <label>Сектор № {currentSector?.id}</label>
                    <label className="labelInfo">
                        {editType === 'begin' ? ' Угол включения.' : ' Угол выключения.'}
                    </label>
                    <h4 className="labelInfoQuet">
                        {hasError ? ("Передумали?") : ("Желаете установить "+`${inputValue}`+ '\u00b0'+'?')}
                    </h4>
                    <h4 className='labelInfoQuet'>
                        {"Следите за заданием угла включения и выключения. Создавайте расписание без перекрытий секторов."}
                    </h4>
                    <h4 className='labelInfoQuet'> {"Сектор должен быть создан полностью."} </h4>
                    <h4 className='labelInfoQuet'> {"Для отключения значения - задайте 0."} </h4>
                    {showOverlapWarning && (
                        <h4 className='labelInfoQuet' style={{color: 'red'}}>
                            {"Внимание: После этого изменения останутся перекрывающиеся сектора!"}
                        </h4>
                    )}
                </div>
                <div className="contentControl">
                    <input
                        type="text"
                        className="input"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{border: hasError ? '1px solid red' : null}}
                        placeholder="0-359"
                    />
                    <div className="modalButton">
                        <Button onClick={() => setModalOpen(false)} color="#d2e9d2">Отмена</Button>
                        <Button onClick={saveSectorValue} color="#4bdd4b">Сохранить</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}